import {AfterViewInit, Component, ElementRef, QueryList, Renderer2, ViewChildren} from '@angular/core';
import {register} from 'swiper/element/bundle';
import {AlertController, IonicSlides, ModalController} from '@ionic/angular';
import Swiper from "swiper";
import {ParentService} from "../../services/mygreencountry/parent.service";
import {PreloaderService} from "../../services/preloader/preloader.service";
import {EducationalBlock, GroupProgress, IntermediateExam} from "../../types/interfaces";
import {ActivatedRoute} from "@angular/router";
import {PersistenceService} from "../../services/mygreencountry/persistence.service";
import {StudentRequestComponent} from "../../shared/components/modals/student-request/student-request.component";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {DomSanitizer, SafeResourceUrl, Title} from "@angular/platform-browser";
import {ViewTestComponent} from "../../shared/components/modals/view-test/view-test.component";
import {TranslocoService} from "@jsverse/transloco";
import {Observable} from "rxjs";


register();

@Component({
    selector: 'app-study-progress',
    templateUrl: './study-progress.page.html',
    styleUrls: ['./study-progress.page.scss'],
})
export class StudyProgressPage implements AfterViewInit {
    lang = 'uk';
    title$: Observable<string>;

    swiperModules = [IonicSlides];
    @ViewChildren('swiper') swiper?: QueryList<ElementRef<{ swiper: Swiper }>>;
    @ViewChildren('container') containers: QueryList<ElementRef>;


    groupIds: any[] | undefined = undefined;
    activeChild$ = this.parentService.getActiveChild();
    childPhone: string | undefined = undefined;
    childId: number | undefined = undefined;
    showSlideArrows: boolean = false;

    typeGroup: string | null = null;
    showFutureProgress: boolean = false;


    public showHiddenTitles: boolean = false;
    public groupsProgress: GroupProgress[] | undefined = undefined;
    public intermediateExams: IntermediateExam[] | undefined = undefined;
    public targetGroup: string | null = null;
    public activeGroupIndex: number = 0;
    public maxShowTitle: number = 3;
    public openBlocksIds: string[] = [];

    swiperBreakpoints = {
        300: {slidesPerView: 2, spaceBetween: 10},
        640: {slidesPerView: 2, spaceBetween: 10},
        768: {slidesPerView: 3, spaceBetween: 15},
        1024: {slidesPerView: 4, spaceBetween: 15}
    };

    constructor(private parentService: ParentService,
                private preloaderService: PreloaderService,
                private route: ActivatedRoute,
                private persistenceService: PersistenceService,
                private modalCtrl: ModalController,
                public myGcService: MyGreenCountry,
                public alertCtrl: AlertController,
                private renderer: Renderer2,
                private sanitizer: DomSanitizer,
                private translocoService: TranslocoService,
                private titleService: Title
    ) {
        this.translocoService.langChanges$.subscribe(language => {
            this.lang = language;
        })

        this.title$ = this.translocoService.selectTranslate('route.studyProgress');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });
    }


    ngOnInit() {
        register();
    }

    ionViewDidEnter() {
        this.typeGroup = this.route.snapshot.paramMap.get('type');

        if (this.typeGroup === 'future') {
            this.showFutureProgress = true;
        } else {
            this.targetGroup = this.route.snapshot.paramMap.get('id');

            let groupIds = this.persistenceService.get('currentPaidGroupsIds') as number[]

            if (this.typeGroup === 'past') {
                groupIds = this.persistenceService.get('pastPaidGroupsIds') as number[]
            }

            if (groupIds) {
                this.groupIds = groupIds;
            }

            let child = this.activeChild$.getValue();

            if (child && this.groupIds) {
                this.childPhone = child.phone
                this.childId = child.id;

                this.loadProgress(child.id, this.groupIds);
            }

            this.updateMaxShowTitle(window.innerWidth);
        }
    }

    refresh(event: any) {
        if (this.groupIds && this.childId) {
            this.loadProgress(this.childId, this.groupIds, event);
        }
    }

    updateMaxShowTitle(width: number) {
        if (width < 768) {
            this.maxShowTitle = 1;
        } else {
            this.maxShowTitle = 3;
        }
    }

    toggleHiddenTitles(event: Event, block: EducationalBlock): void {
        event.stopPropagation()

        let target = event.currentTarget as HTMLElement;
        this.renderer.addClass(target, 'd-none');
        this.showHiddenTitles = !this.showHiddenTitles;
    }

    openPopover(event: Event,): void {
        event.stopPropagation()
        let target = event.currentTarget as HTMLElement;
        let studyProgressElement = target.nextElementSibling;

        if (studyProgressElement && studyProgressElement.classList.contains('study-progress')) {
            if (studyProgressElement.classList.contains('d-flex')) {
                this.renderer.removeClass(studyProgressElement, 'd-flex');
                this.renderer.addClass(studyProgressElement, 'd-none');
            } else {
                this.renderer.removeClass(studyProgressElement, 'd-none');
                this.renderer.addClass(studyProgressElement, 'd-flex');
            }
        }
    }


    hideHiddenTitle(block: EducationalBlock) {
        let blockItem = document.querySelector('.item-block-' + block.id)

        if (blockItem) {
            let isOpen = blockItem.classList.contains('open');

            if (isOpen) {
                this.showHiddenTitles = false;
                this.renderer.removeClass(blockItem, 'open');
                let openTitleElement = document.querySelector('.addition-' + block.id)

                if (openTitleElement) {
                    this.renderer.removeClass(openTitleElement, 'd-none');
                }

            } else {
                this.renderer.addClass(blockItem, 'open');
            }
        }
    }


    ngAfterViewInit() {
    }

    async loadProgress(id: number, groupIds: { id: number, target: boolean }[], event: any = null) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.parentService.getStudentStudyProgress(id, groupIds)
            .subscribe({

                next: (response) => {
                    this.intermediateExams = response.education.intermediateExams
                    this.groupsProgress = response.education.groups

                    this.groupsProgress.forEach(progress => {
                        let openBlocksId = progress.blocks.filter(item => item.show).map(item => item.id.toString());
                        this.openBlocksIds.push(openBlocksId[0]);

                    });


                },

                error: (error) => {
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();
                    if (event) {
                        event.target.complete();
                    }
                }

            })
    }

    onSlidePrev(swiperElement: HTMLElement) {
        const swiperInstance = (swiperElement as any).swiper;
        if (swiperInstance) {
            swiperInstance.slidePrev(800);
        }
    }


    onSlideNext(swiperElement: HTMLElement) {
        const swiperInstance = (swiperElement as any).swiper;
        if (swiperInstance) {
            swiperInstance.slideNext(800);
        }
    }

    getButtonText(exam: any): string {
        if (exam.status === 'finished') {
            return 'Переглянути';
        } else if (!exam.passed) {
            return 'Переглянути';
        } else {
            return 'Замовити доступ';
        }
    }

    /*getTabsAttribute() {

        if (this.groupsProgress && this.groupsProgress.length > 0) {

            this.groupTitles = Array.from(new Set(this.groupsProgress.map(item => item.title)));

            this.groupTitles = this.groupsProgress.map(item => item.title);

            this.groupTitles.forEach(title => {
                this.activeTabs[title] = false;
            });


            let activeGroupIndex: number = 0;

            if (this.targetGroup) {

                activeGroupIndex = this.groupTitles.indexOf(this.targetGroup);
            }

            if (this.groupTitles[activeGroupIndex]) {
                this.activeTabs[this.groupTitles[activeGroupIndex]] = true;
            }

        }

    }*/

    async openRequestModal(type: string) {

        const modal = await this.modalCtrl.create({
            component: StudentRequestComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                type: type,
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();
    }


    async getResultExam(uuid: string) {
        if (this.childPhone) {

            await this.preloaderService.showLoading("Зачекайте, будь ласка ");

            this.myGcService.getExamResultsUrl(this.childPhone, uuid)
                .subscribe({

                    next: (response) => {
                        if (response.success) {
                            this.openTestModal(response.url)
                        } else {

                            this.alert(
                                '',
                                response.message,
                                [{
                                    text: 'ok',
                                    handler: (data: any) => {
                                    }
                                }]);

                        }
                    },

                    error: (error) => {
                        console.log('error', error)

                    },

                    complete: () => {
                        this.preloaderService.hideLoading();
                    }

                })
        }


    }

    async openTestModal(url: string) {

        const safeUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

        const modal = await this.modalCtrl.create({
            component: ViewTestComponent,
            cssClass: 'auto-height full-height',
            componentProps: {
                url: safeUrl
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }

    async alert(header: string, subHeader: string, buttons: any = []) {

        let alert = await this.alertCtrl.create({
            header: header,
            subHeader: subHeader,
            buttons: buttons
        });
        await alert.present();

    }


    showMoreInfo(j: number, i: number, block: EducationalBlock) {
        this.hideHiddenTitle(block);

        let className = `content_${j}_${i}`;
        let arrowClass = `arrow_${i}`;

        let container = this.getContainerByIndex(j);

        if (!container) {
            return;
        }

        let element = container.nativeElement.querySelector(`.${className}`);
        let elementArrow = container.nativeElement.querySelector(`.${arrowClass}`);

        if (element) {
            this.toggleClass(element, 'd-none');
        }
        if (elementArrow) {
            this.toggleClass(elementArrow, 'up');
        }
    }

    private getContainerByIndex(index: number): ElementRef | undefined {
        let containersArray = this.containers.toArray();

        return containersArray[index];
    }

    private toggleClass(element: HTMLElement, className: string) {
        if (element.classList.contains(className)) {
            this.renderer.removeClass(element, className);
        } else {
            this.renderer.addClass(element, className);
        }
    }
}
